import axios from 'axios';

const API_BASE_URL = '/api/saas';
const AUTH_API_BASE_URL = '/api/auth';

// Get auth token from localStorage
const getAuthToken = () => localStorage.getItem('authToken');

// Axios instance with auth header for SaaS API
const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

// Axios instance for new unified auth API
const authApi = axios.create({
  baseURL: AUTH_API_BASE_URL,
});

authApi.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API - uses new unified authentication system
export const authAPI = {
  register: (data: any) => authApi.post('/register/', data),
  // Gated login (2026-07-08). The old /api/saas/login/ authenticates against
  // Django's blog.User via authenticate() and CANNOT authenticate a
  // users.SaveDeleteUser, so email-registered accounts had no working login.
  // Point at /api/auth/login/ which checks SaveDeleteUser and returns the same
  // {token, user} on 200, or 403 {verification_required, email} for unverified.
  // AuthContext passes {username, password}; the gated view reads `email`, so
  // map it here (login field accepts an email address).
  login: (data: any) =>
    authApi.post('/login/', { email: data.username ?? data.email, password: data.password }),
  // Email-verification OTP flow (2026-07-08). verify-email accepts {email, code}
  // OR {token}; on success returns the same {token, user} payload as login.
  verifyEmail: (data: { email?: string; code?: string; token?: string }) =>
    authApi.post('/verify-email/', data),
  resendVerification: (email: string) =>
    authApi.post('/resend-verification/', { email }),
  logout: () => api.post('/logout/'),
  getProfile: () => api.get('/profile/'),
  updateProfile: (data: any) => api.put('/profile/', data),
};

export default api;
